const ParentsInfoOk = {
  SET_PARENT_SIRE_INFO_OK: 'SET_PARENT_SIRE_INFO_OK',
  SET_PARENT_DAM_INFO_OK: 'SET_PARENT_DAM_INFO_OK',
};

export default ParentsInfoOk;
